import React, { useState, useContext, useEffect, useCallback } from 'react'
import { TextField, FormGroup, FormControlLabel, Checkbox } from '@mui/material'
import CardHeader from './CardHeader'
import { DataRoomsContext, MessageContext } from './Contexts' 
import { UpdateRoom } from 'modules/Rest'
import { setModes } from 'modules/Utils'
import { useSelectedDataRoom } from 'hooks/useSelectedDataRoom'

function DataRoomNameCard() {
  const { setRefreshNext, refreshNext, triggerRefresh } = useContext(DataRoomsContext)
  const { dataRoom } = useSelectedDataRoom()
  const { messageDispatch } = useContext(MessageContext)
  const [mode, setMode] = useState('')
  const [publicName, setPublicName] = useState(dataRoom.data_room_public_name)
  const [privateName, setPrivateName] = useState(dataRoom.data_room_name)
  const [changeTopFolderName, setChangeTopFolderName] = useState(true)

  const setInitialState = useCallback(() => {
    setPublicName(dataRoom.data_room_public_name)
    setPrivateName(dataRoom.data_room_name)
    setChangeTopFolderName(true)
  }, [dataRoom.data_room_name, dataRoom.data_room_public_name])

  useEffect(() => {
    setInitialState()
  }, [dataRoom.data_room, setInitialState])

  const submit = async (e, setMode) => {
    try {
      setMode('pending')
      const { data: { success, info } } = await UpdateRoom({
        data_room: dataRoom.data_room,
        data_room_public_name: publicName,
        data_room_name: privateName,
        change_top_folder_name: changeTopFolderName,
      })
      setRefreshNext(true)
      if (success) {
        setModes(setMode, ['completing', 1500, ''])
      } else {
        throw new Error(info ? info : 'An error occurred')
      }
    } catch (error) {
      messageDispatch({ type: 'warning', payload: error.message })
      setMode('')
    }
  }

  const cancel = (e, setMode) => {
    if (refreshNext) {
      triggerRefresh()
    } else {
      setInitialState()
    }
    setMode('')
  }

  return <>
    <CardHeader
      mode={mode}
      setMode={setMode}
      action={submit}
      cancel={cancel}
      title='Data room name'
      headingElement='subtitle1'
      btnParams={{editTitle: 'Edit name'}}
      noMargin={true}
    />
    <form noValidate autoComplete='off'>
      <FormGroup row>
        <TextField
          label='Public name'
          value={publicName}
          onChange={event => setPublicName(event.target.value)}
          disabled={mode !== 'editing'}
          variant="standard"
          fullWidth
        />
      </FormGroup>
      <FormGroup row>
        <TextField
          label='Private name'
          value={privateName}
          onChange={event => setPrivateName(event.target.value)}
          variant="standard"
          disabled={mode !== 'editing'}
          fullWidth
        />
      </FormGroup>
      {mode === 'editing' && <FormGroup row>
        <FormControlLabel
          control={<Checkbox
            onChange={event => setChangeTopFolderName(event.target.checked)}
            checked={changeTopFolderName}
          />}
          label='Change name of top folder as well'
          disabled={mode !== 'editing'}
        />
      </FormGroup>}
    </form>
  </>
}

export default DataRoomNameCard
